import React, { useCallback } from 'react'
import { WhiteBox } from '@/components/Layout'
import { DataLoader } from '@/components/dataLoader'
import context from '@/context'
import { InfoContent, InfoLabel, InfoRow } from '@/components/InfoRow'
import { Link } from 'react-router-dom'
import LoadingIndicator from '@/components/LoadingIndicator'
import { Name } from '@/components/Name'
import Resx from '@/components/Resx'

export function UserAccountInfo ({ id }) {
  const dataSource = useCallback(() => context.api.userManagementService.getUserByIndividual(id), [id])
  return (
    <WhiteBox header='Individuals.Account'>
      <DataLoader dataSource={dataSource} render={({ data, loading }) => (
        loading
          ? <LoadingIndicator />
          : data
            ? (
              <React.Fragment>
                {context.isInternalApp() &&
                <React.Fragment>
                  <InfoRow>
                    <InfoLabel><Resx name='UsersManagement.AccountType' /></InfoLabel>
                    <InfoContent><Resx name={data.isInternalUser ? 'UsersManagement.AccountTypeInternal' : 'UsersManagement.AccountTypeExternal'} /></InfoContent>
                  </InfoRow>
                  {!data.isInternalUser &&
                  <InfoRow>
                    <InfoLabel><Resx name='Institutions.Institution' /></InfoLabel>
                    <InfoContent>{data.allowedInstitutions.map(x => {
                      return (
                        <React.Fragment key={x.id}>
                          <Name data={x} />
                          <br />
                        </React.Fragment>
                      )
                    })}</InfoContent>
                  </InfoRow>
                  }
                </React.Fragment>
                }
                <InfoRow>
                  <InfoLabel><Resx name='UsersManagement.EmailAddress' /></InfoLabel>
                  <InfoContent>{data.emailAddress}</InfoContent>
                </InfoRow>
                {data.userName !== data.emailAddress &&
                  <InfoRow>
                    <InfoLabel><Resx name='Individuals.UserName' /></InfoLabel>
                    <InfoContent>{data.userName}</InfoContent>
                  </InfoRow>
                }
                <InfoRow>
                  <InfoLabel><Resx name='Individuals.AccountStatus' /></InfoLabel>
                  <InfoContent><Resx name={data.isActive ? 'UsersManagement.Active' : 'UsersManagement.Blocked'} /></InfoContent>
                </InfoRow>
                <div className='text-right mt-3'>
                  <Link className='btn btn-xs btn-secondary' to={`/users/${data.id}`}>
                    <Resx name='UsersManagement.Detail' />
                  </Link>
                </div>
              </React.Fragment>
            )
            : <p><Resx name='Individuals.NoUserAccount' /></p>

      )} />
    </WhiteBox>
  )
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/individuals/userAccountInfo.js